<template>
  <banners
    :sticky-top="true"
    :narrow="true"
  >
    <div class="w-full">
      <div
        v-if="loading"
        class="mx-auto flex h-80 max-w-2xl items-center justify-center py-12 sm:overflow-scroll md:overflow-hidden"
      >
        <img
          class="-top-2px loading relative h-12 w-full"
          src="@/assets/loading-v2-yellow.svg"
          alt=""
        />
      </div>
      <div
        v-if="!loading"
        class="relative w-full"
      >
        <!-- <div class="absolute top-0 left-0 right-0 w-full h-120 bg-off-white"></div> -->
        <div
          v-if="
            !(
              latest_carrier_eld_provider?.connect_channel?.eld_type ==
                'eld_exempt' &&
              latest_carrier_eld_provider?.has_setup_manual_connection == true
            )
          "
          class="max-h-0 overflow-hidden bg-off-white text-left transition-all duration-700 ease-in-out"
          :class="[showHeroSection ? 'max-h-full lg:max-h-140' : '']"
        >
          <div
            class="container-max relative mx-auto flex w-full flex-col items-center justify-between gap-8 px-4 px-6 py-20 md:flex-row md:px-10"
          >
            <div class="max-w-md">
              <h2 class="mb-6 text-4xl">Welcome, {{ displayName }}!</h2>
              <div class="max-w-md text-base text-body-color">
                <p
                  v-if="!latest_carrier_eld_provider?.id"
                  class="mb-4"
                >
                  We're glad you're here. For the best experience, connect your
                  ELD to verify your equipment and build trust and visibility
                  among our community of brokers.
                </p>
                <p
                  v-else
                  class="mb-4"
                >
                  We're glad you're here. Find the best freight for your
                  business by quickly and securely connecting with our community
                  of brokers.
                </p>
              </div>
            </div>
            <div
              v-if="
                !latest_carrier_eld_provider?.id ||
                latest_carrier_eld_provider?.has_setup_manual_connection ==
                  false
              "
              class="max-w-md"
            >
              <div
                class="flex flex-col items-center justify-center rounded-lg bg-dark-gray bg-opacity-5 p-8 shadow-primary-bold"
              >
                <div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    class="h-24 w-24 text-yellow-500"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M1.371 8.143c5.858-5.857 15.356-5.857 21.213 0a.75.75 0 010 1.061l-.53.53a.75.75 0 01-1.06 0c-4.98-4.979-13.053-4.979-18.032 0a.75.75 0 01-1.06 0l-.53-.53a.75.75 0 010-1.06zm3.182 3.182c4.1-4.1 10.749-4.1 14.85 0a.75.75 0 010 1.061l-.53.53a.75.75 0 01-1.062 0 8.25 8.25 0 00-11.667 0 .75.75 0 01-1.06 0l-.53-.53a.75.75 0 010-1.06zm3.204 3.182a6 6 0 018.486 0 .75.75 0 010 1.061l-.53.53a.75.75 0 01-1.061 0 3.75 3.75 0 00-5.304 0 .75.75 0 01-1.06 0l-.53-.53a.75.75 0 010-1.06zm3.182 3.182a1.5 1.5 0 012.122 0 .75.75 0 010 1.061l-.53.53a.75.75 0 01-1.061 0l-.53-.53a.75.75 0 010-1.06z"
                      clip-rule="evenodd"
                    />
                  </svg>
                </div>
                <h3 class="mb-3 text-xl">Connect your ELD</h3>
                <p class="mb-6 text-center text-body-color">
                  Build trust and visibility to get more freight.
                </p>
                <!-- <p class="text-center mb-6 text-body-color">Link your ELD to unlock access to instantly connect with our network of brokers.</p> -->
                <button-main
                  variant="primary"
                  class="portal-btn group"
                  @click="handleConnectELDClick"
                >
                  Connect ELD
                  <svg
                    class="relative -top-0.5 left-0.5 inline"
                    width="21"
                    height="21"
                    viewBox="0 0 21 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M14.3945 15.2305L19.3726 20.1232"
                      stroke="white"
                      stroke-width="1.89396"
                    />
                    <circle
                      cx="9.62468"
                      cy="9.62566"
                      r="8.05075"
                      stroke="white"
                      stroke-width="1.89396"
                    />
                    <path
                      d="M5.55664 9.3486L8.2119 11.9151L13.7638 6.54883"
                      stroke="white"
                      stroke-width="1.89396"
                    />
                  </svg>
                </button-main>
              </div>
            </div>
            <div
              v-else-if="
                !latest_carrier_eld_provider?.integration?.id ||
                hasInvalidEldCredentials ||
                hasUnverifiedEldCredentials
              "
              class="max-w-md"
            >
              <div
                class="flex flex-col items-center justify-center rounded-lg bg-dark-gray bg-opacity-5 p-8 shadow-primary-bold"
              >
                <div>
                  <!-- <div class="bg-clip-border bg-gradient-to-t from-yellow-500 to-yellow-10" style="background-image: radial-gradient(#f8c617, #fef9e8); clip-path: url(#clip0); height: 96px; width: 96px;"> -->
                  <div>
                    <svg
                      v-if="hasInvalidEldCredentials"
                      id="eld-wifi-disconnected"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                      class="text-placeholder-gray"
                      style="height: 96px; width: 96px"
                    >
                      <defs>
                        <clipPath
                          id="clip0-x"
                          clipPathUnits="objectBoundingBox"
                        >
                          <!-- <path id="wifi-overlay" fill-rule="evenodd" d="M1.371 8.143c5.858-5.857 15.356-5.857 21.213 0a.75.75 0 010 1.061l-.53.53a.75.75 0 01-1.06 0c-4.98-4.979-13.053-4.979-18.032 0a.75.75 0 01-1.06 0l-.53-.53a.75.75 0 010-1.06zm3.182 3.182c4.1-4.1 10.749-4.1 14.85 0a.75.75 0 010 1.061l-.53.53a.75.75 0 01-1.062 0 8.25 8.25 0 00-11.667 0 .75.75 0 01-1.06 0l-.53-.53a.75.75 0 010-1.06zm3.204 3.182a6 6 0 018.486 0 .75.75 0 010 1.061l-.53.53a.75.75 0 01-1.061 0 3.75 3.75 0 00-5.304 0 .75.75 0 01-1.06 0l-.53-.53a.75.75 0 010-1.06zm3.182 3.182a1.5 1.5 0 012.122 0 .75.75 0 010 1.061l-.53.53a.75.75 0 01-1.061 0l-.53-.53a.75.75 0 010-1.06z" clip-rule="evenodd" /> -->
                          <circle
                            cx="0.5"
                            cy="1.01"
                            r="0"
                          />
                          <!-- <rect width="7" height="7" fill="black" /> -->
                        </clipPath>
                      </defs>
                      <path
                        id="wifi-disconnected"
                        fill-rule="evenodd"
                        d="M1.371 8.143c5.858-5.857 15.356-5.857 21.213 0a.75.75 0 010 1.061l-.53.53a.75.75 0 01-1.06 0c-4.98-4.979-13.053-4.979-18.032 0a.75.75 0 01-1.06 0l-.53-.53a.75.75 0 010-1.06zm3.182 3.182c4.1-4.1 10.749-4.1 14.85 0a.75.75 0 010 1.061l-.53.53a.75.75 0 01-1.062 0 8.25 8.25 0 00-11.667 0 .75.75 0 01-1.06 0l-.53-.53a.75.75 0 010-1.06zm3.204 3.182a6 6 0 018.486 0 .75.75 0 010 1.061l-.53.53a.75.75 0 01-1.061 0 3.75 3.75 0 00-5.304 0 .75.75 0 01-1.06 0l-.53-.53a.75.75 0 010-1.06zm3.182 3.182a1.5 1.5 0 012.122 0 .75.75 0 010 1.061l-.53.53a.75.75 0 01-1.061 0l-.53-.53a.75.75 0 010-1.06z"
                        clip-rule="evenodd"
                        mask="url(#diagonal-mask)"
                      />
                      <use
                        clip-path="url(#clip0-x)"
                        href="#wifi-disconnected"
                        fill="#C7CBDB"
                      />
                      <rect
                        transform="rotate(138)"
                        x="-2.5"
                        y="-26"
                        width="1"
                        height="21"
                        fill="#C7CBDB"
                      />
                      <mask id="diagonal-mask">
                        <rect
                          x="0"
                          y="0"
                          width="24"
                          height="24"
                          fill="white"
                        />
                        <!-- <line x1="18" y1="13" x2="0" y2="-1" stroke="black" stroke_width="7"/> -->
                        <!-- <rect transform="rotate(45)" x="8.5" y="-11" width="4" height="17" fill="black"/> -->
                        <rect
                          transform="rotate(138)"
                          x="-3.75"
                          y="-26"
                          width="3.5"
                          height="24"
                          fill="black"
                        />
                      </mask>
                    </svg>
                    <svg
                      v-else
                      id="eld-wifi"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                      class="text-yellow-100"
                      style="height: 96px; width: 96px"
                    >
                      <defs>
                        <clipPath
                          id="clip0"
                          clipPathUnits="objectBoundingBox"
                        >
                          <!-- <path id="wifi-overlay" fill-rule="evenodd" d="M1.371 8.143c5.858-5.857 15.356-5.857 21.213 0a.75.75 0 010 1.061l-.53.53a.75.75 0 01-1.06 0c-4.98-4.979-13.053-4.979-18.032 0a.75.75 0 01-1.06 0l-.53-.53a.75.75 0 010-1.06zm3.182 3.182c4.1-4.1 10.749-4.1 14.85 0a.75.75 0 010 1.061l-.53.53a.75.75 0 01-1.062 0 8.25 8.25 0 00-11.667 0 .75.75 0 01-1.06 0l-.53-.53a.75.75 0 010-1.06zm3.204 3.182a6 6 0 018.486 0 .75.75 0 010 1.061l-.53.53a.75.75 0 01-1.061 0 3.75 3.75 0 00-5.304 0 .75.75 0 01-1.06 0l-.53-.53a.75.75 0 010-1.06zm3.182 3.182a1.5 1.5 0 012.122 0 .75.75 0 010 1.061l-.53.53a.75.75 0 01-1.061 0l-.53-.53a.75.75 0 010-1.06z" clip-rule="evenodd" /> -->
                          <circle
                            cx="0.5"
                            cy="1.01"
                            r="0"
                          />
                        </clipPath>
                      </defs>
                      <path
                        id="wifi"
                        fill-rule="evenodd"
                        d="M1.371 8.143c5.858-5.857 15.356-5.857 21.213 0a.75.75 0 010 1.061l-.53.53a.75.75 0 01-1.06 0c-4.98-4.979-13.053-4.979-18.032 0a.75.75 0 01-1.06 0l-.53-.53a.75.75 0 010-1.06zm3.182 3.182c4.1-4.1 10.749-4.1 14.85 0a.75.75 0 010 1.061l-.53.53a.75.75 0 01-1.062 0 8.25 8.25 0 00-11.667 0 .75.75 0 01-1.06 0l-.53-.53a.75.75 0 010-1.06zm3.204 3.182a6 6 0 018.486 0 .75.75 0 010 1.061l-.53.53a.75.75 0 01-1.061 0 3.75 3.75 0 00-5.304 0 .75.75 0 01-1.06 0l-.53-.53a.75.75 0 010-1.06zm3.182 3.182a1.5 1.5 0 012.122 0 .75.75 0 010 1.061l-.53.53a.75.75 0 01-1.061 0l-.53-.53a.75.75 0 010-1.06z"
                        clip-rule="evenodd"
                      />
                      <use
                        clip-path="url(#clip0)"
                        href="#wifi"
                        fill="#f8c617"
                      />
                    </svg>
                  </div>
                </div>
                <div
                  class="relative -top-2 h-auto w-48 rounded-b-xl px-3 pb-3 pt-0"
                >
                  <img
                    v-if="
                      latest_carrier_eld_provider?.connect_channel?.logo?.url
                    "
                    class="mx-auto w-full"
                    :src="
                      latest_carrier_eld_provider?.connect_channel?.logo?.url
                    "
                    :alt="latest_carrier_eld_provider?.connect_channel?.name"
                  />
                  <div
                    v-else
                    class="w-full text-center font-semibold tracking-tighter"
                  >
                    {{ latest_carrier_eld_provider?.connect_channel?.name }}
                  </div>
                </div>
                <template v-if="hasInvalidEldCredentials">
                  <h3 class="mb-3 text-xl">Invalid ELD Account Credentials</h3>
                  <p class="text-center text-body-color">
                    The provided
                    {{ latest_carrier_eld_provider?.connect_channel?.name }}
                    account credentials are invalid. Please provide valid
                    credentials to connect your ELD account.
                  </p>
                  <button-main
                    variant="primary"
                    class="portal-btn group mt-6"
                    @click="handleConnectELDClickUpdate"
                  >
                    Update Credentials
                    <svg
                      class="relative -top-0.5 left-0.5 inline"
                      width="21"
                      height="21"
                      viewBox="0 0 21 21"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M14.3945 15.2305L19.3726 20.1232"
                        stroke="currentColor"
                        stroke-width="1.89396"
                      />
                      <circle
                        cx="9.62468"
                        cy="9.62566"
                        r="8.05075"
                        stroke="currentColor"
                        stroke-width="1.89396"
                      />
                      <path
                        d="M5.55664 9.3486L8.2119 11.9151L13.7638 6.54883"
                        stroke="currentColor"
                        stroke-width="1.89396"
                      />
                    </svg>
                  </button-main>
                </template>
                <template v-else>
                  <h3 class="mb-3 text-xl">ELD Connection in Progress</h3>
                  <p class="text-center text-body-color">
                    We're currently working on connecting to your
                    {{ latest_carrier_eld_provider?.connect_channel?.name }}
                    account. You'll be notified here when the connection is
                    complete.
                  </p>
                  <button-main
                    variant="secondary"
                    class="portal-btn group mt-6"
                    style="background: transparent !important"
                    @click="handleConnectELDClickUpdate"
                  >
                    Update Credentials
                    <svg
                      class="relative -top-0.5 left-0.5 inline"
                      width="21"
                      height="21"
                      viewBox="0 0 21 21"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M14.3945 15.2305L19.3726 20.1232"
                        stroke="currentColor"
                        stroke-width="1.89396"
                      />
                      <circle
                        cx="9.62468"
                        cy="9.62566"
                        r="8.05075"
                        stroke="currentColor"
                        stroke-width="1.89396"
                      />
                      <path
                        d="M5.55664 9.3486L8.2119 11.9151L13.7638 6.54883"
                        stroke="currentColor"
                        stroke-width="1.89396"
                      />
                    </svg>
                  </button-main>
                </template>
              </div>
            </div>
          </div>
        </div>

        <div v-if="carrier_loads_enabled">
          <div class="container-max mx-auto p-4 md:px-10">
            <div class="flex flex-col gap-4 lg:flex-row">
              <div>
                <div
                  v-if="showReliabilityScore"
                  class="sm:min-w-[500px]"
                >
                  <ReliabilityScoreCard score="90"></ReliabilityScoreCard>
                </div>

                <div
                  v-if="carrier_loads_enabled"
                  class="min-w-[400px]"
                >
                  <div class="my-4 flex items-center justify-between lg:hidden">
                    <p class="header-text leading-tight text-dark-blue">
                      My Loads
                    </p>
                    <router-link
                      :to="{ name: 'My Loads' }"
                      class="rounded-md bg-light-gray px-2 py-1 text-sm"
                      href="/"
                    >
                      View All
                    </router-link>
                  </div>

                  <div
                    class="flex items-center justify-between gap-4 rounded-lg border border-light-gray bg-white px-4 py-3 shadow-lg lg:min-h-[160px] lg:flex-col lg:py-4"
                  >
                    <div
                      class="hidden w-full items-center justify-between lg:flex"
                    >
                      <p
                        class="header-text leading-tight text-dark-blue lg:!text-xl lg:font-semibold"
                      >
                        My Loads
                      </p>
                      <router-link
                        :to="{ name: 'My Loads' }"
                        class="rounded-md bg-light-gray px-2 py-1 text-sm"
                        href="/"
                      >
                        View All
                      </router-link>
                    </div>

                    <div class="flex w-full justify-between">
                      <div>
                        <p class="mb-1 text-gray-600">{{ loads?.length }}</p>
                        <p>Dispatch</p>
                      </div>
                      <div>
                        <p class="mb-1 text-gray-600">
                          {{ transit_loads_length }}
                        </p>
                        <p>Transit</p>
                      </div>
                      <div>
                        <p class="mb-1 text-gray-600">
                          {{ completed_loads_length }}
                        </p>
                        <p>Completed</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            v-if="carrier_loads_enabled && loads?.length > 0"
            class="container-max mx-auto p-4 md:px-10"
          >
            <p class="header-text leading-tight text-dark-blue">
              Dispatch ({{ loads?.length }})
            </p>

            <div class="my-4 flex gap-4 overflow-scroll">
              <div
                v-for="load in loads"
                :key="load.id"
                class=""
              >
                <LoadDetail
                  :load="load"
                  className="w-[300px] md:w-[400px]"
                ></LoadDetail>
              </div>
            </div>
          </div>
        </div>

        <div class="container-max mx-auto w-full px-4 py-10 text-left md:px-10">
          <div>
            <div class="flex w-full items-end justify-between pb-8">
              <p class="header-text leading-tight text-dark-blue">My Brokers</p>
            </div>
            <div
              v-if="connections?.length > 0"
              class="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3"
            >
              <div
                v-for="connection in connections"
                :key="connection?.id"
                class="flex h-full w-full flex-col"
              >
                <conditional-wrapper
                  :condition="linkable_broker && connection.carrier_id"
                  wrapper="router-link"
                  :wrapperProps="{
                    to: {
                      name: 'Carrier Brokers Show Page',
                      params: { id: connection.carrier_id },
                    },
                    target: '_blank',
                  }"
                >
                  <div
                    class="flex h-full w-full flex-col overflow-hidden rounded-lg border border-light-gray shadow-primary hover:shadow-primary-bold"
                  >
                    <div class="flex h-full flex-col">
                      <div
                        class="relative flex h-36 w-full items-center justify-center overflow-hidden border-b border-light-gray bg-white pb-4 pt-8"
                      >
                        <div
                          class="absolute right-1 top-1.5 flex items-center justify-between"
                        >
                          <!-- <div class="flex items-center rounded-full bg-yellow-50 border-yellow-300 border h-6 overflow-hidden">
                        <p class="text-2xs text-yellow-500 pl-1.5 relative -right-0.5">
                          Connected {{ formatDate(connection?.connection_created_at) }}
                        </p>
                        <img
                          class="w-8 h-8 position relative"
                          style="top: 0.2rem;"
                          src="@/assets/highway-badge-2.svg"
                          alt="highway badge"
                        />
                      </div> -->
                          <div
                            class="flex h-10 items-center overflow-hidden rounded-full"
                          >
                            <img
                              class="position relative h-12 w-12"
                              style="top: 0.2rem"
                              src="@/assets/highway-badge-2.svg"
                              alt="highway badge"
                            />
                          </div>
                        </div>
                        <div
                          v-if="connection?.logo?.url"
                          class="relative flex flex-col items-center gap-1"
                        >
                          <img
                            :src="connection?.logo?.url"
                            :alt="connection?.legal_name"
                            class="max-h-24 max-w-70pct"
                            style="margin-bottom: 0px"
                          />
                          <!-- <div class="relative opacity-0 flex flex-col items-center justify-start">
                        <div class="bg-gradient-to-b from-transparent to-alt-white absolute inset-0 z-10"></div>
                        <img
                          :src="connection?.logo?.url"
                          :alt="connection?.legal_name"
                          class="broker-logo2 transform -scale-y-100 relative z-0 h-18 max-w-80pct opacity-70"
                          style="margin-bottom: 0px;"
                        />
                      </div> -->
                        </div>
                        <!-- <img
                      v-else
                      src="@/assets/placeholder-logo.svg"
                      alt="placeholder logo"
                      class="broker-logo2"
                    /> -->
                        <svg
                          v-else
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          fill="currentColor"
                          class="h-full w-auto text-light-gray"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M1.5 6a2.25 2.25 0 012.25-2.25h16.5A2.25 2.25 0 0122.5 6v12a2.25 2.25 0 01-2.25 2.25H3.75A2.25 2.25 0 011.5 18V6zM3 16.06V18c0 .414.336.75.75.75h16.5A.75.75 0 0021 18v-1.94l-2.69-2.689a1.5 1.5 0 00-2.12 0l-.88.879.97.97a.75.75 0 11-1.06 1.06l-5.16-5.159a1.5 1.5 0 00-2.12 0L3 16.061zm10.125-7.81a1.125 1.125 0 112.25 0 1.125 1.125 0 01-2.25 0z"
                            clip-rule="evenodd"
                          />
                        </svg>
                      </div>
                      <div
                        class="flex flex-grow flex-col justify-between gap-3 bg-dark-gray p-4"
                      >
                        <div>
                          <div class="flex items-start justify-between gap-1.5">
                            <p
                              class="text-base font-bold leading-5 text-off-white"
                            >
                              {{ connection?.legal_name }}
                            </p>
                            <div class="inline-block flex-shrink-0">
                              <div>
                                <p
                                  v-if="
                                    connection?.overall_rule_result === 'fail'
                                  "
                                  class="fail-status whitespace-nowrap"
                                >
                                  Access Disabled
                                </p>
                                <p
                                  v-else-if="
                                    connection?.overall_rule_result ===
                                    'incomplete'
                                  "
                                  class="incomplete-status whitespace-nowrap"
                                >
                                  Access Pending
                                </p>
                                <p
                                  v-else
                                  class="pass-status whitespace-nowrap"
                                >
                                  Access Enabled
                                </p>
                              </div>
                            </div>
                          </div>
                          <div class="pb-4">
                            <p class="mb-1 text-xxs text-gray-over-dark">
                              Connected
                              {{
                                formatDate(connection?.connection_created_at)
                              }}
                            </p>
                            <div
                              class="inline-block max-w-full overflow-hidden text-ellipsis"
                            >
                              <a
                                v-if="connection?.support_email"
                                :href="`mailto:${connection?.support_email}`"
                                class="group relative -left-2 flex transform items-center gap-1.5 rounded-full px-2 py-1 text-yellow-500 transition ease-in-out hover:translate-x-2 hover:bg-yellow-500 hover:bg-opacity-30"
                              >
                                <!-- <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-3 h-3 flex-shrink-0">
                              <path d="M1.5 8.67v8.58a3 3 0 003 3h15a3 3 0 003-3V8.67l-8.928 5.493a3 3 0 01-3.144 0L1.5 8.67z" />
                              <path d="M22.5 6.908V6.75a3 3 0 00-3-3h-15a3 3 0 00-3 3v.158l9.714 5.978a1.5 1.5 0 001.572 0L22.5 6.908z" />
                            </svg> -->
                                <!-- <svg class="h-3 w-3 flex-shrink-0 text-gray-over-dark group-hover:text-yellow-500" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg" data-v-01ef35fe="">
                              <path d="M2.66671 3.05762H13.3334C14.0667 3.05762 14.6667 3.65762 14.6667 4.39095V12.391C14.6667 13.1243 14.0667 13.7243 13.3334 13.7243H2.66671C1.93337 13.7243 1.33337 13.1243 1.33337 12.391V4.39095C1.33337 3.65762 1.93337 3.05762 2.66671 3.05762Z" stroke="currentColor" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" data-v-01ef35fe=""></path>
                              <path d="M14.6667 4.39062L8.00004 9.05729L1.33337 4.39062" stroke="currentColor" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" data-v-01ef35fe=""></path>
                            </svg> -->
                                <svg
                                  class="h-3 w-3 flex-shrink-0"
                                  viewBox="0 0 16 17"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                  data-v-01ef35fe=""
                                >
                                  <path
                                    d="M2.66671 3.05762H13.3334C14.0667 3.05762 14.6667 3.65762 14.6667 4.39095V12.391C14.6667 13.1243 14.0667 13.7243 13.3334 13.7243H2.66671C1.93337 13.7243 1.33337 13.1243 1.33337 12.391V4.39095C1.33337 3.65762 1.93337 3.05762 2.66671 3.05762Z"
                                    stroke="currentColor"
                                    stroke-width="1.33333"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    data-v-01ef35fe=""
                                  />
                                  <path
                                    d="M14.6667 4.39062L8.00004 9.05729L1.33337 4.39062"
                                    stroke="currentColor"
                                    stroke-width="1.33333"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    data-v-01ef35fe=""
                                  />
                                </svg>
                                <span
                                  class="text-ellipsis whitespace-nowrap text-xxs"
                                  >{{ connection?.support_email }}</span
                                >
                              </a>
                            </div>
                          </div>
                        </div>
                        <button-main
                          :variant="
                            isAssessmentPass(connection?.overall_rule_result)
                              ? 'primary'
                              : 'secondary-over-dark'
                          "
                          class="portal-btn group cursor-pointer bg-dark-gray"
                          @click="goToBrokerPortal(connection)"
                        >
                          <span
                            v-if="
                              isAssessmentPass(connection?.overall_rule_result)
                            "
                            >Enter</span
                          >
                          <span v-else>View Status</span>
                          <svg
                            class="tester link-icon inline"
                            :class="
                              isAssessmentPass(connection?.overall_rule_result)
                                ? 'text-white'
                                : ''
                            "
                            width="25"
                            height="24"
                            viewBox="0 0 25 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M12.5 6H7.5C6.94772 6 6.5 6.44772 6.5 7V17C6.5 17.5523 6.94772 18 7.5 18H17.5C18.0523 18 18.5 17.5523 18.5 17V12"
                              stroke="currentColor"
                              stroke-width="2"
                            />
                            <path
                              d="M18.6748 5.78174L14.0262 10.4304M18.6748 5.78174L18.6748 9.43214M18.6748 5.78174L15.0244 5.78174"
                              stroke="currentColor"
                              stroke-width="2"
                            />
                          </svg>
                        </button-main>
                      </div>
                    </div>
                  </div>
                </conditional-wrapper>
              </div>
            </div>
            <div
              v-else
              class="mt-6 rounded-lg bg-off-white px-6 pb-8 pt-8"
            >
              <p class="notice-text">
                You currently do not have any connections with Brokers.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="!loading"
        class="relative w-full"
      >
        <div class="absolute left-0 right-0 top-0 h-72 w-full bg-off-white" />
        <div
          class="container-max relative mx-auto w-full px-4 py-10 text-left md:px-10"
        >
          <div class="container-max">
            <p class="header-text mb-8 text-dark-blue">Available Connections</p>
            <section
              v-if="availableConnections?.length > 0"
              class="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3"
            >
              <div
                v-for="(connection, idx) in availableConnections"
                :key="idx"
                class="mb-6 flex flex-col overflow-hidden rounded-lg border border-light-gray shadow-primary hover:shadow-primary-bold"
              >
                <div
                  class="relative flex h-36 w-full items-center justify-center border-b border-light-gray bg-white py-4"
                >
                  <img
                    v-if="connection?.logo?.url"
                    :src="connection?.logo?.url"
                    :alt="connection?.legal_name"
                    class="max-h-24 max-w-70pct"
                    style="margin-bottom: 0px"
                  />
                  <!-- <img
                        v-else
                        src="@/assets/placeholder-logo.svg"
                        alt="placeholder logo"
                        class="broker-logo2"
                      /> -->
                  <svg
                    v-else
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    class="h-full w-auto text-light-gray"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M1.5 6a2.25 2.25 0 012.25-2.25h16.5A2.25 2.25 0 0122.5 6v12a2.25 2.25 0 01-2.25 2.25H3.75A2.25 2.25 0 011.5 18V6zM3 16.06V18c0 .414.336.75.75.75h16.5A.75.75 0 0021 18v-1.94l-2.69-2.689a1.5 1.5 0 00-2.12 0l-.88.879.97.97a.75.75 0 11-1.06 1.06l-5.16-5.159a1.5 1.5 0 00-2.12 0L3 16.061zm10.125-7.81a1.125 1.125 0 112.25 0 1.125 1.125 0 01-2.25 0z"
                      clip-rule="evenodd"
                    />
                  </svg>
                </div>
                <div
                  class="flex flex-grow flex-col justify-between gap-3 bg-alt-white p-4"
                >
                  <div>
                    <p class="text-base font-bold text-dark-gray">
                      {{ connection?.legal_name }}
                    </p>
                    <div class="pb-4">
                      <div
                        class="inline-block max-w-full overflow-hidden text-ellipsis"
                      >
                        <a
                          v-if="connection?.support_email"
                          :href="`mailto:${connection?.support_email}`"
                          class="group relative -left-2 flex transform items-center gap-1.5 rounded-full px-2 py-1 text-yellow-500 transition ease-in-out hover:translate-x-2 hover:bg-yellow-500 hover:bg-opacity-20"
                        >
                          <!-- <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-3 h-3 flex-shrink-0">
                                <path d="M1.5 8.67v8.58a3 3 0 003 3h15a3 3 0 003-3V8.67l-8.928 5.493a3 3 0 01-3.144 0L1.5 8.67z" />
                                <path d="M22.5 6.908V6.75a3 3 0 00-3-3h-15a3 3 0 00-3 3v.158l9.714 5.978a1.5 1.5 0 001.572 0L22.5 6.908z" />
                              </svg> -->
                          <svg
                            class="h-3 w-3 flex-shrink-0 text-gray-over-dark group-hover:text-yellow-600"
                            viewBox="0 0 16 17"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            data-v-01ef35fe=""
                          >
                            <path
                              d="M2.66671 3.05762H13.3334C14.0667 3.05762 14.6667 3.65762 14.6667 4.39095V12.391C14.6667 13.1243 14.0667 13.7243 13.3334 13.7243H2.66671C1.93337 13.7243 1.33337 13.1243 1.33337 12.391V4.39095C1.33337 3.65762 1.93337 3.05762 2.66671 3.05762Z"
                              stroke="currentColor"
                              stroke-width="1.33333"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              data-v-01ef35fe=""
                            />
                            <path
                              d="M14.6667 4.39062L8.00004 9.05729L1.33337 4.39062"
                              stroke="currentColor"
                              stroke-width="1.33333"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              data-v-01ef35fe=""
                            />
                          </svg>
                          <span
                            class="text-ellipsis whitespace-nowrap text-xxs text-gray-over-dark group-hover:text-yellow-600"
                            >{{ connection?.support_email }}</span
                          >
                        </a>
                      </div>
                    </div>
                  </div>
                  <button-main
                    variant="primary"
                    class="portal-btn group"
                    :disabled="connection?.sign_in_with_highway_link === null"
                    @click="
                      redirectToHighwayLink(
                        connection?.sign_in_with_highway_link
                      )
                    "
                  >
                    Connect
                    <svg
                      class="tester link-icon inline text-white"
                      width="25"
                      height="24"
                      viewBox="0 0 25 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12.5 6H7.5C6.94772 6 6.5 6.44772 6.5 7V17C6.5 17.5523 6.94772 18 7.5 18H17.5C18.0523 18 18.5 17.5523 18.5 17V12"
                        stroke="currentColor"
                        stroke-width="2"
                      />
                      <path
                        d="M18.6748 5.78174L14.0262 10.4304M18.6748 5.78174L18.6748 9.43214M18.6748 5.78174L15.0244 5.78174"
                        stroke="currentColor"
                        stroke-width="2"
                      />
                    </svg>
                  </button-main>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
    <dialog
      id="dialog"
      class="dialog-carrier-dashboard outline-none"
    >
      <carrier-portal-eld-provider-modal />
    </dialog>
  </banners>
</template>

<script type="text/javascript">
import moment from 'moment';
import ButtonMain from '@/components/Button.vue';
import Banners from '@/components/Banners.vue';
import CONFIG from '@/config';
import rulesSyntax from '@/common/rulesSyntax.js';
import CarrierPortalEldProviderModal from '@/components/modals/CarrierPortalEldProviderModal.vue';
import ConditionalWrapper from '../../components/ConditionalWrapper.vue';
import LoadDetail from '@/components/loads/LoadDetail.vue';
import { loadQuery } from '../../utils/loadFilters.js';
import ReliabilityScoreCard from '@/components/loads/ReliabilityScoreCard.vue';

export default {
  name: 'Carrier Brokers',
  components: {
    Banners,
    ButtonMain,
    CarrierPortalEldProviderModal,
    ConditionalWrapper,
    LoadDetail,
    ReliabilityScoreCard,
  },
  data() {
    return {
      rulesSyntax,
      preferredNameModalVisible: false,
      confirmCompanyEmailModalVisible: false,
      has_incomplete_eld: true,
    };
  },
  computed: {
    displayName() {
      return this.currentUser?.preferred_name || this.currentUser?.first_name;
    },
    showHeroSection() {
      return (
        (!this.latest_carrier_eld_provider?.integration?.id ||
          this.hasInvalidEldCredentials ||
          this.hasUnverifiedEldCredentials) &&
        this.latest_carrier_eld_provider_has_loaded
      );
      // return this.latest_carrier_eld_provider?.id > 0 && this.latest_carrier_eld_provider_has_loaded;
    },
    hasInvalidEldCredentials() {
      return (
        (this.latest_carrier_eld_provider?.integration
          ?.eld_credentials_verified === false &&
          this.latest_carrier_eld_provider?.connect_channel
            ?.is_auto_eld_credentials) ||
        this.latest_carrier_eld_provider?.integration?.revoked_at !== null
      );
    },
    hasUnverifiedEldCredentials() {
      return (
        this.latest_carrier_eld_provider?.integration
          ?.eld_credentials_verified === null &&
        this.latest_carrier_eld_provider?.connect_channel
          ?.is_auto_eld_credentials
      );
    },
    hasValidEldCredentials() {
      return (
        this.latest_carrier_eld_provider?.integration
          ?.eld_credentials_verified &&
        this.latest_carrier_eld_provider?.connect_channel
          ?.is_auto_eld_credentials
      );
    },
    currentEldIntegration() {
      return this.$store.state.onboardingPacket?.current_eld_integration;
    },
    updateEld() {
      return this.$route?.query?.updateEld || false;
    },
    connectEld() {
      return this.$route?.query?.connectEld || false;
    },
    connections() {
      let conns = [...this.$store.state.brokers.connections];
      return conns.filter(
        (conn) => conn?.company_id !== 1 && conn?.status !== 'do_not_dispatch'
      );
    },
    loading() {
      return this.$store.state.loading.isLoading;
    },
    empty() {
      return this.$store.state.loading.isEmpty;
    },
    availableConnections() {
      const userConnections = this.connections;
      const allAvailableConnections =
        this.$store.state.brokers.availableConnections;

      const filteredConnections = allAvailableConnections?.filter(
        (connection) => {
          return !userConnections?.some(
            (userConnection) => userConnection?.company_id === connection?.id
          );
        }
      );

      return filteredConnections.length
        ? filteredConnections
        : allAvailableConnections;
    },
    currentUser() {
      return this.$store.state.users?.currentUser;
    },
    latest_carrier_eld_provider() {
      if (this.$store.state.onboardingPacket?.latest_carrier_eld_provider) {
        return this.$store.state.onboardingPacket?.latest_carrier_eld_provider;
      } else if (
        this.$store.state.carriers?.carrierData?.latest_carrier_eld_provider
      ) {
        return this.$store.state.carriers?.carrierData
          ?.latest_carrier_eld_provider;
      }
      return null;
    },
    latest_carrier_eld_provider_has_loaded() {
      return this.$store.state.onboardingPacket
        ?.latest_carrier_eld_provider_has_loaded;
    },
    linkable_broker() {
      return this.$store.state.users.featureFlags?.onboarding_linkable_brokers
        ?.enabled;
    },
    carrier_loads_enabled() {
      return false;
      // return this.$store.state.users.featureFlags?.enable_carrier_loads
      //   ?.enabled;
    },
    carrier_load_board_enabled() {
      return this.$store.state.users.currentUser?.scopes?.includes(
        'carrier_view_posted_loads'
      );
    },
    // has_incomplete_eld() {
    //   // TODO -- Hardcoded for testing
    //   return false;

    //   // return (
    //   //   !this.latest_carrier_eld_provider?.id ||
    //   //   this.latest_carrier_eld_provider?.has_setup_manual_connection == false
    //   // );
    // },
    can_load_board_search() {
      // TODO -- Hardcoded for testing
      return true;

      // Carrier is onboarded,
      // IDV'd,
      // has connected ELD,
      // connected to broker,
      // and broker supports load board
      // if (
      //   !this.has_incomplete_eld &&
      //   this.$store.state.users.currentUser?.identity_proofing_status !==
      //     'require_identity_proofing' &&
      //   this.connections?.length > 0
      // ) {
      //   return true;
      // }

      // return false
    },
    loads() {
      return this.$store.state.loads?.dispatch || [];
    },
    transit_loads_length() {
      return this.$store.state.loads?.transit?.length || 0;
    },
    completed_loads_length() {
      return this.$store.state.loads?.completed?.length || 0;
    },
    showReliabilityScore() {
      return false;
    },
  },
  watch: {
    updateEld: {
      handler: function (val) {
        if (val) {
          this.handleConnectELDClick();
          this.$store.commit('integrations/setUpdateEld', true);
          this.$router.replace({ query: { updateEld: false } });
        }
      },
    },
    latest_carrier_eld_provider: {
      handler: function (val) {
        if (
          val &&
          val?.id > 0 &&
          this.$store.state.onboardingPacket?.current_eld_integration === null
        ) {
          this.$store.dispatch('onboardingPacket/getMostRecentEldIntegration');
        }
      },
    },
  },
  async created() {
    this.$store.commit('loading/loadingToggleOn', null, {
      root: true,
    });
    this.$store.commit('loading/emptyToggleOn', null, {
      root: true,
    });
    await this.$store.dispatch('brokers/getBrokers', {
      query: '/?q[s]=issuer_legal_name+asc',
    });
    await this.$store.dispatch('brokers/getAvailableConnections');
    await this.$store.dispatch(
      'onboardingPacket/getLatestEldProvider',
      this.$store.state.users?.currentUser?.company?.carrier_id
    );
    await this.$store.dispatch('loads/getLoads', {
      query: loadQuery['dispatch'],
      status: 'dispatch',
    });
    await this.$store.dispatch('loads/getLoads', {
      query: loadQuery['transit'],
      status: 'transit',
    });
    await this.$store.dispatch('loads/getLoads', {
      query: loadQuery['completed'],
      status: 'completed',
    });
    await this.$store.dispatch(
      'loads/getCarrierVehicles',
      this.$store.state.users?.currentUser?.company?.carrier_id
    );
  },
  mounted() {
    if (this.connectEld) {
      this.handleConnectELDClick();
    }
    if (this.updateEld) {
      this.handleConnectELDClick();
      this.$store.commit('integrations/setUpdateEld', true);
      this.removeUpdateEld();
    }
    if (this.$route?.query?.message) {
      this.$toast.open({
        message: this.$route.query?.message?.replaceAll('+', ' '),
        type: 'success',
        duration: 5000,
        dismissible: true,
        position: 'top-right',
      });

      this.$router.replace({
        query: {
          ...this.$route.query,
          message: undefined,
        },
      });
    }
    this.removeRedirectAfterIDV();
  },
  methods: {
    removeRedirectAfterIDV() {
      localStorage?.removeItem('redirectAfterIDV');
    },
    handleBroadcastEvent(event) {
      console.log(event);
      if (event == 'approved') {
        this.preferredNameModalVisible = true;
      }
    },
    removeUpdateEld() {
      // eslint-disable-next-line
      this.$router.push({ name: this.$route.name }).catch((err) => {});
    },
    handleConnectELDClickUpdate() {
      this.$store.commit('integrations/setUpdateEld', true);
      this.handleConnectELDClick();
    },
    handleConnectELDClick() {
      const dialog = document.getElementById('dialog');
      dialog?.showModal();
    },
    redirectToHighwayLink(link) {
      if (process.env.ENV_URL?.includes('localhost')) {
        link = link.replace('https://staging.highway.com', process.env.ENV_URL);
      }
      window.open(link, '_blank');
    },
    formatDate(date) {
      return moment(date).format('M/D/YY');
    },
    getFilteredRules(rulesAssessment) {
      return Object.entries(rulesAssessment).filter(([key, value]) => {
        return (
          value !== null &&
          !['carrier_id', 'company_id', 'overall_result'].includes(key)
        );
      });
    },
    getFailedRules(rulesAssessment) {
      let filteredRules = this.getFilteredRules(rulesAssessment);
      // eslint-disable-next-line
      let failedRulesArray = filteredRules.filter(([key, value]) => {
        return value === 'fail';
      });
      return failedRulesArray.map((el) => el[0]);
    },
    getIncompleteRules(rulesAssessment) {
      let filteredRules = this.getFilteredRules(rulesAssessment);
      // eslint-disable-next-line
      let incompleteRulesArray = filteredRules.filter(([key, value]) => {
        return value === 'incomplete';
      });
      return incompleteRulesArray.map((el) => el[0]);
    },
    goToBrokerPortal(connection) {
      const { client_id, redirect_uri } = connection;
      let encodedURI = encodeURIComponent(redirect_uri);
      window.open(
        `${CONFIG.ENV_URL}${CONFIG.BASE_URL}oauth/authorizations?response_type=code&client_id=${client_id}&scope=onboarding&redirect_uri=${encodedURI}`,
        '_blank'
      );
      // window.location.href = `${CONFIG.ENV_URL}${CONFIG.BASE_URL}oauth/authorizations?response_type=code&state=1&client_id=${client_id}&scope=onboarding&redirect_uri=${encodedURI}`;
      // window.open(
      //   `https:${CONFIG.ENV_URL}${CONFIG.BASE_URL}oauth/authorizations?response_type=code&state=1&client_id=${client_id}&scope=onboarding&redirect_uri=${encodedURI}`,
      //   '_blank'
      // );
    },
    goToOnboardingPacketStatus(latest_onboarding_packet_id) {
      if (latest_onboarding_packet_id > 0) {
        window.open(
          process.env.ENV_URL +
            process.env.BASE_URL +
            'carrier/onboarding_packets/' +
            latest_onboarding_packet_id +
            '/status',
          '_blank'
        );
        // this.$router.push({
        //   name: "Carrier Onboarding Packet Status",
        //   params: {
        //     id: latest_onboarding_packet_id,
        //   },
        // });
      }
    },
    isAssessmentPass(text) {
      return ['pass', 'partial_pass'].includes(text);
    },
    handleLetsGo() {
      this.has_incomplete_eld = false;
    },
  },
};
</script>

<style scoped>
dialog {
  border-radius: 10px;
}

.dialog-carrier-dashboard {
  margin: 5vh auto;
}

@media (min-width: 640px) {
  .dialog-carrier-dashboard {
    margin: 7.5vh auto;
  }
}

dialog::backdrop {
  background-color: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(7px);
}

.header-text {
  font-size: 26px;
}
.subheader-text {
  font-size: 18px;
}

.notice-text {
  @apply text-center text-body-color;
  font-size: 13px;
}

.fail-status {
  padding: 4px 8px;
  background: #fff0e3;
  border-radius: 30px;
  font-size: 10px;
  /* width: 34px; */
  height: 24px;
  @apply text-orange-600;
}

.pass-status {
  padding: 4px 8px;
  background: #ddf4e3;
  border-radius: 30px;
  font-size: 10px;
  /* width: 40px; */
  height: 24px;
  @apply text-green-600;
}

.incomplete-status {
  padding: 4px 8px;
  background: #d6d7da;
  border-radius: 30px;
  font-size: 10px;
  /* width: 74px; */
  height: 24px;
}

::marker {
  font-size: 14px;
  margin-right: 20px;
  @apply text-body-color;
}

ul li {
  list-style-type: disc;
  list-style-position: inside;
  @apply mb-2 ml-6 text-1md;
  /* padding: 10px 0 10px 20px; */
  text-indent: -1em;
}

.link-icon {
  position: relative;
  bottom: 1px;
}

.notice-text {
  @apply text-center text-gray-over-dark;
  font-size: 16px;
}

/* .portal-btn[disabled] > .tester {
    @apply text-light-gray group-hover:text-light-gray;
  } */

@keyframes wifiCircle {
  /* 0%, 6.5% {
      r: 0.25;
    }
    7.5%, 15% {
      r: 0.5;
    }
    16%, 23.5% {
      r: 0.75;
    }
    24.5% {
      r: 1.01;
    }
    100% {
      r: 1.01;
    } */
  0%,
  3.25% {
    r: 0.25;
  }
  3.75%,
  7.5% {
    r: 0.5;
  }
  8%,
  11.75% {
    r: 0.75;
  }
  12.25% {
    r: 1.01;
  }
  100% {
    r: 1.01;
  }
}

#clip0 circle {
  animation: wifiCircle 5s infinite ease-in-out;
}

@keyframes wifiSVG {
  0%,
  25%,
  62.5%,
  100% {
    opacity: 1;
  }
  43.75%,
  81.25% {
    opacity: 0.5;
  }
}

#eld-wifi {
  animation: wifiSVG 5s infinite ease-in-out;
}

.hide-small {
  display: none;
}
@media (min-width: 360px) {
  .hide-small {
    display: initial;
  }
}
</style>
